/**
 *  A dedicated Reducer for the CEO Circle of Excellence hall of fame
 */

const initState = {
    list: [],
    isListLoaded : false,
    loadError : false, // the last fetch failed before any list arrived
}

// Keeps the API order (year desc, then name asc) after a local insert / update.
const sortAwardees = (list) => {
    return list.slice().sort((a, b) => {
        return (Number(b.year) - Number(a.year)) || String(a.name || "").localeCompare(String(b.name || ""));
    });
}

const ceoCircleReducers = (state = initState, action) => {

    switch(action.type) {

        case "FETCH_CEO_CIRCLE_SUCCESS":
            return {
                ...state,
                list : Array.isArray(action.list) ? action.list : [],
                isListLoaded : true,
                loadError : false
            };

        case "FETCH_CEO_CIRCLE_FAILED":
            return {
                ...state,
                loadError : true
            };

        case "CEO_CIRCLE_SAVED": {
            const item = action.item;
            if (!item) return state;
            const others = state.list.filter((a) => a.id !== item.id);
            return {
                ...state,
                list : sortAwardees(others.concat([item]))
            };
        }

        case "CEO_CIRCLE_DELETED":
            return {
                ...state,
                list : state.list.filter((a) => a.id !== action.id)
            };

        default:
            return state;
    }
}

export default ceoCircleReducers;
